import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as ENV } from 'src/environments/environment';
import { ApiEndpoints as API } from '../../config/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class DocusignService {
  private headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  returnURL: string = `${ENV.baseUrl.web}docusign-confirmation`;

  constructor(
    private http: HttpClient
  ) { }

  postEnvelopeData(request): Observable<any> {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.SEND_ENVELOPE}`, request, { headers: this.headers });
  }

  //Checks if a particular document has been signed
  checkEnvelopeStatus(envelopeId: string, signerEmail: string, trackingNumber: string): Observable<any> {
    const params = new HttpParams()
      .set('EnvelopeId', envelopeId)
      .set('signerEmail', signerEmail)
      .set('BOLTrackingNumber', trackingNumber);
    return this.http.get<any>(`${ENV.baseUrl.api}${API.CHECK_DOCUSIGN_STATUS}`, { params });
  }

  signalGWCCDocusignUpload(request): Observable<any> {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.UPLOAD_DOCUSIGN_DOCUMENT}`, request, { headers: this.headers },);
  }

  sendDocusignFailureEmail(request): Observable<any> {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.DOCUSIGN_FAILURE_EMAIL}`, request, { headers: this.headers });
  }
}
